import React, { useState } from 'react';
import { Box, TextField, Button, Select, MenuItem, FormControl, InputLabel, Typography, Paper, CircularProgress } from '@mui/material';
import { crearSolicitud } from '../services/api'; 

const SolicitudForm = () => {
  const [formData, setFormData] = useState({
    tipo_solicitud: 'PETICION',
    descripcion: '',
    nombre_ciudadano: '',
    email_ciudadano: '',
    es_anonima: false,
  });
  
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // --- NUEVO GUARDIA DE SEGURIDAD FRONTEND ---
    if (!formData.nombre_ciudadano.trim() || !formData.email_ciudadano.trim() || !formData.descripcion.trim()) {
      alert("Por favor, completa todos los campos obligatorios (Descripción, Nombre y Correo).");
      return; // Detiene la ejecución aquí mismo
    }

    setLoading(true); 

    try {
      const response = await crearSolicitud(formData);
      alert(`¡Solicitud creada con éxito! Tu código de seguimiento es: ${response.data.codigo_seguimiento}`);
      
      setFormData({
        tipo_solicitud: 'PETICION',
        descripcion: '',
        nombre_ciudadano: '',
        email_ciudadano: '',
        es_anonima: false,
      });

    } catch (error) {
      console.error("Hubo un error al crear la solicitud:", error);
      alert("Error al enviar la solicitud. Por favor, revisa los datos e inténtalo de nuevo.");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Crear una Nueva Solicitud
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="tipo-solicitud-label">Tipo de Solicitud</InputLabel>
          <Select
            labelId="tipo-solicitud-label"
            id="tipo_solicitud"
            name="tipo_solicitud"
            value={formData.tipo_solicitud}
            label="Tipo de Solicitud"
            onChange={handleChange}
          >
            <MenuItem value="QUEJA">Queja</MenuItem>
            <MenuItem value="DENUNCIA">Denuncia</MenuItem>
            <MenuItem value="PETICION">Petición</MenuItem>
            <MenuItem value="RECLAMO">Reclamo</MenuItem>
            <MenuItem value="SUGERENCIA">Sugerencia</MenuItem>
          </Select>
        </FormControl>

        <TextField
          margin="normal" required fullWidth id="descripcion"
          label="Descripción detallada de su caso" name="descripcion"
          multiline rows={5} value={formData.descripcion} onChange={handleChange}
        />

        {/* --- CAMPOS ACTUALIZADOS --- */}
        <TextField
          margin="normal" required fullWidth id="nombre_ciudadano"
          label="Nombre y Apellido" name="nombre_ciudadano"
          value={formData.nombre_ciudadano} onChange={handleChange}
        />

        <TextField
          margin="normal" required fullWidth id="email_ciudadano"
          label="Correo Electrónico" name="email_ciudadano" type="email"
          value={formData.email_ciudadano} onChange={handleChange}
        />

        <Box sx={{ position: 'relative' }}>
          <Button
            type="submit" fullWidth variant="contained"
            disabled={loading} 
            sx={{ mt: 3, mb: 2, py: 1.5 }}
          >
            Enviar Solicitud
          </Button>
          {loading && (
            <CircularProgress
              size={24}
              sx={{
                position: 'absolute', top: '50%', left: '50%',
                marginTop: '-12px', marginLeft: '-12px',
              }}
            />
          )}
        </Box>
      </Box>
    </Paper>
  );
}

export default SolicitudForm;
